import { createContext, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getItem, postItem } from "../Api/Api";
const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState({
    name: "",
    role: "",
  });
  const [error, setError] = useState(null);
  const [screen, setScreen] = useState(JSON.parse(localStorage.getItem("puslapis")) || "/");
  const [previousScreen, setPreviousScreen] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;

    if (currentPath !== screen && screen !== "") {
      setPreviousScreen(screen);
      localStorage.setItem("buvesPuslapis", screen);
    }
  }, [location, screen]);

  useEffect(() => {
    user.name === "" &&
      getItem("user")
        .then((data) => {
          const userData = data.data && {
            name: data.data.vardas,
            role: data.data.pareigos,
          };
          setUser(userData);
          navigate(screen);
        })
        .catch(() => {
          navigate("/login");
        });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const handlePopState = () => {
      const currentPath = window.location.pathname;

      setScreen(currentPath);
      setPreviousScreen(screen);
      localStorage.setItem("puslapis", JSON.stringify(currentPath));
      localStorage.setItem("buvesPuslapis", screen);
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [screen]);

  const login = (data, setLoading, setTimer) => {
    setLoading(true);
    postItem("login", data)
      .then((data) => {
        const userData = data.data && {
          name: data.data.vardas,
          role: data.data.pareigos,
        };
        setUser(userData);
        setError(null);
        navigate(screen);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.response.data.klaida);
        setLoading(false);
        setTimer(err.response.data.stabdymas || 0);
      });
  };

  const logout = () => {
    postItem("logout", null)
      .then(() => {
        setUser({ name: "", role: "" });
        navigate("/login");
      })
      .catch((err) => {
        err.response && console.log(err.response.data);
      });
  };

  const removeError = () => {
    setError(null);
  };

  const changeScreen = (value) => {
    setPreviousScreen(screen);
    localStorage.setItem("buvesPuslapis", screen);

    if (value !== "/" && value !== "/karves-rodikliai") {
      localStorage.removeItem("homeFilters");
      localStorage.removeItem("selectedKarve");
      localStorage.removeItem("selectedKarves");
      localStorage.removeItem("rodikliaiFilters");
    }

    setScreen(value);
    localStorage.setItem("puslapis", JSON.stringify(value));
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        error,
        screen,
        previousScreen,
        login,
        logout,
        removeError,
        changeScreen,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;

export const useAuth = () => {
  return useContext(AuthContext);
};
